import { render, staticRenderFns } from "./asManage.vue?vue&type=template&id=78ca19fb"
import script from "./asManage.vue?vue&type=script&lang=js"
export * from "./asManage.vue?vue&type=script&lang=js"
import style0 from "./asManage.vue?vue&type=style&index=0&id=78ca19fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports